export default "__VITE_ASSET__pKcFjBgL__"